import React from 'react'
import Switch from '@mui/material/Switch'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'

// Presentational "show all locations" toggle — a small labelled switch, rendered inside the tab it
// belongs to (Attestera, Översikt). It holds no state: each tab owns its own persisted preference
// and passes checked + onChange, so the two tabs are independent.
export default function AllScopesToggle({ checked, onChange }: {
    checked: boolean,
    onChange: () => void,
}) {
    return (
        <FormControlLabel
            // MUI defaults FormControlLabel to marginLeft: -11px (it pulls the control into the
            // margin to cancel the switch's ripple padding). Left at that, the switch hangs left of
            // every sibling's edge; ml: 0 lines it up with the selects and table cards above/below.
            sx={{ ml: 0, mr: 0 }}
            control={<Switch size="small" checked={checked} onChange={() => onChange()} />}
            label={<Typography variant="body2">Visa alla kostnadsställen</Typography>}
        />
    )
}
